import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bytesToSize',
  pure: false
})
export class BytesToSizePipe implements PipeTransform {
  transform(bytes: number): string {
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    if (+bytes === 0) {
      return '0 B';
    }
    const i = Math.floor(Math.log(bytes) / Math.log(1000));
    return Math.round((bytes / Math.pow(1000, i)) * 10) / 10 + ' ' + sizes[i];
  }
}
